import React, { Component } from "react";
import TextBox from "./TextBox";
import CheckBox from "./CheckBox";
import RadioButton from "./RadioButton";
import DropDown from "./DropDown";
import "./InitialFormStyleSheet.css";

class InitialFormDetails extends Component {
  constructor(props) {
    super(props);
    this.items =
      this.props.config && this.props.config.form
        ? this.props.config.form.sort((i1, i2) => {
            return i1.selposition - i2.selposition;
          })
        : [];

    this.components = this.items.map((item) => {
      const ref = React.createRef();
      if (item.seltype === "checkBox") {
        return {
          item,
          ref,
          component: <CheckBox ref={ref} item={item} key={item.selposition} />,
        };
      } else if (item.seltype === "dropDown") {
        return {
          item,
          ref,
          component: <DropDown ref={ref} item={item} key={item.selposition} />,
        };
      } else if (item.seltype === "radioButton") {
        return {
          item,
          ref,
          component: (
            <RadioButton ref={ref} item={item} key={item.selposition} />
          ),
        };
      } /* 'txtBox' */ else {
        return {
          item,
          ref,
          component: <TextBox ref={ref} item={item} key={item.selposition} />,
        };
      }
    });
  }

  render() {
    // Sort form items by selposition.
    return (
      <>
        <div
          className="s360-initial-form-details-container"
          style={this.containerStyle()}
        >
          {this.components.map((component) => (
            <>
              {component.component}
              <br />
            </>
          ))}
        </div>
        <div className={"s360-initial-form-start-button-container"}>
          <input
            className="s360-initial-form-start-button"
            type="button"
            value="Start Chat"
            onClick={this.startChat}
            style={this.buttonStyle()}
          />
        </div>
      </>
    );
  }

  containerStyle = () => {
    return {
      backgroundColor: this.props.config.designDetails.pageBackgroundColor,
    };
  };

  buttonStyle = () => {
    return {
      background: this.props.config.designDetails.selectionButtonColor,
      color: this.props.config.designDetails.selectionButtonTextColor,
      fontFamily: this.props.config.designDetails.selectionButtonFont,
      fontSize: this.props.config.designDetails.selectionButtonFontSize + "px",
    };
  };

  startChat = () => {
    // TODO: Add validations for fields.
    let invalidOptions = this.components.filter((component) => {
      return !component.ref.current.validate();
    });
    const isValid = invalidOptions.length === 0;
    if (isValid) {
      let params = {};
      this.components.forEach(
        (component) =>
          (params = { ...params, ...component.ref.current.value() })
      );
      this.props.actions.startChat(params);
    } else if (invalidOptions.length > 0) {
      let errorMessage = invalidOptions[0].ref.current.validationErrorMessage();
      this.props.actions.showPopUpMessage(errorMessage);
      invalidOptions[0].ref.current.focus = true;
    }
  };
}
export default InitialFormDetails;
